////////////////////////////////////////20260331///////////////////////////////////////////

import React from 'react'
import { useState } from 'react'
import Out_Main_contract from './Out_Main_contract'
import Out_Basic_contract from './Out_Basic_contract'
import Out_Contract_signature from './Out_Contract_signature'
import { StampModal } from '../../service/components/Modals'
import { useLocation } from 'react-router-dom'
import Toptabs from '../../service/components/Toptabs'
import { STEP } from '../Project/projectStepManager'

function Out_contract({
    userId,
    detail,
    detailProject,
    openModalHandler,
    isOpen,
    num,
    setNum,
    userinfo,
    setStampid,
    stampid,
    divref,
    setDetail,
}) {
    const location = useLocation()
    const searchParams = new URLSearchParams(location.search)

    const [fresh, setFresh] = useState(false)

    const onFresh = () => {
        setFresh(!fresh)
    }

    function getStepOrder(step) {
        var orderMap = {}

        orderMap[STEP.TEMP] = 0
        orderMap[STEP.REGISTER] = 1
        orderMap[STEP.ESTIMATE_WRITE] = 2
        orderMap[STEP.ESTIMATE_RECEIVE] = 3
        orderMap[STEP.ESTIMATE_APPROVE] = 4
        orderMap[STEP.CONTRACT_WRITE] = 5
        orderMap[STEP.CONTRACT_SIGN] = 6
        orderMap[STEP.DEPOSIT] = 7
        orderMap[STEP.DEV1] = 8
        orderMap[STEP.MIDDLE] = 9
        orderMap[STEP.DEV2] = 10
        orderMap[STEP.FINAL_REPORT] = 11
        orderMap[STEP.FINAL_PAY] = 12
        orderMap[STEP.DONE] = 13

        if (typeof orderMap[step] === 'number') {
            return orderMap[step]
        }

        return -1
    }

    function canViewContract(step) {
        return getStepOrder(step) >= getStepOrder(STEP.CONTRACT_WRITE)
    }

    var currentStep = detailProject && detailProject.adminstatus ? detailProject.adminstatus : ''

    var canViewRealContract = canViewContract(currentStep)
    var isExample = detail && detail.uid === 'exampledata'
    var forceExample = !canViewRealContract || isExample

    return (
        <>
            {num > 0 ? (
                <div className="add_right_wrap outwrap mt0">
                    <div className="flex contractstep_wrap w100">
                        <Toptabs
                            uni={true}
                            data={detail}
                            value={'계약서'}
                            userinfo={userinfo}
                            setNum={setNum}
                            num={num}
                        />
                    </div>
                    <div className="flex center"></div>
                    <div ref={divref}>
                        <div className="quote-container mt10">
                            <div>
                                <Out_Main_contract contract={detail} />
                                <Out_Basic_contract userinfo={userinfo} />
                                <Out_Contract_signature
                                    setStampid={setStampid}
                                    stampid={stampid}
                                    notmain={forceExample ? false : detail.c2f ? true : false}
                                    fresh={fresh}
                                    userinfo={userinfo}
                                    setContract={setDetail}
                                    contract={detail}
                                />
                            </div>
                        </div>
                    </div>
                    {isOpen ? (
                        <StampModal
                            onFresh={onFresh}
                            openModalHandler={openModalHandler}
                            userId={userId}
                            isOpen={isOpen}
                        />
                    ) : (
                        ''
                    )}
                    {forceExample ? <div className="text_absolute">계약서 예시입니다</div> : ''}
                </div>
            ) : (
                ''
            )}
        </>
    )
}

export default Out_contract
